import React from "react";
import './Button.css'

const Button: React.FC<{backgroundColor?: string; color?: string; buttonText?: string, border?: string, height?: string, showLoader?: boolean, onClickHandle?: () => void}> = ({backgroundColor, color, buttonText, showLoader = false, onClickHandle, border, height}) => {
    return (
        <button className="bik-sm-button" onClick={onClickHandle} style={{backgroundColor: backgroundColor, color: color, border: border, height: height}}> 
        {showLoader ? (
                  <div className="loader"></div>
                ) : buttonText
        }
        </button>
    )
}
export default Button